
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sign_up",
      function () {
        return require("private-next-pages/sign_up/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sign_up"])
      });
    }
  